export enum ChampionshipRegistrationPriceMode {
    Regular = "Regular",
    FreeOfCharge = "FreeOfCharge",
    PaidBidWinner = "PaidBidWinner"
}
